<template>
  <vx-card class="overflow-hidden mb-base" title="Statistiques globales" collapse-action>
    <template slot="no-body">
      <div class="p-6">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <div class="flex">
              <div class="mr-6">
                <p class="mb-1 font-semibold">Temps moyen réél</p>
                <p class="text-3xl">{{real_average_time}} min</p>
              </div>
              <div>
                <p class="mb-1 font-semibold">Temps moyen recommandé</p>
                <p class="text-3xl">{{recommended_average_time}} min</p>
              </div>
            </div>
            <vue-apex-charts v-if="!loading"
              type="area"
              height="420"
              :options="timeCharts.options"
              :series="timeCharts.series"/>
          </div>
        </div>
      </div>
    </template>
  </vx-card>
</template>

<script>
  import VueApexCharts from 'vue-apexcharts';

  export default {
    name: "treatmentTimeStats",
    components: {VueApexCharts},

    data: () => ({
      real_average_time: 231,
      recommended_average_time: 89,
      loading: false,
      timeCharts: {
        options: {
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth'
          },
          // colors: themeColors,
          xaxis: {
            categories: [],
          },
          tooltip: {
            x: {
              format: ''
            },

          }
        },
        series: [
          {
            name: 'Temps de traitement réél en min',
            data: []
          },
          {
            name: 'Temps de traitement recommandé en min',
            data: []
          }
        ]
      },
    }),
    methods: {
      getTreatementTimeByRequests() {
        this.loading = true
        this.$vs.loading()
        this.$http.get('/statistics/cc/graph-of-request').then((response) => {
          let datas = response.data;
          this.timeCharts.options.xaxis.categories = [];

          //setup graph
          this.real_average_time = datas.real_average_time;
          this.recommended_average_time = datas.recommended_average_time;

          let actual_processing_time = [];
          let recommended_time = [];
          let request_title = [];

          datas.graph.forEach((data) => {
            actual_processing_time.push(data.actual_processing_time ? data.actual_processing_time : 0);
            recommended_time.push(data.recommended_time ? data.recommended_time : 0);
            //request_title.push(data.request_title ? this.truncateString(data.request_title, 18) : '');
            request_title.push(data.request_title ? data.request_title : '');
          })

          this.timeCharts.options.xaxis.categories = JSON.parse(JSON.stringify(request_title));
          this.timeCharts.series[0].data = JSON.parse(JSON.stringify(actual_processing_time));
          this.timeCharts.series[1].data = JSON.parse(JSON.stringify(recommended_time));

          this.$vs.loading.close()
          this.loading = false
        }).catch((error) => {
        //  console.log(error)
          this.loading = false
          this.$vs.loading.close()
          if (error.response.status === 401) {
            this.$vs.notify({
              title: 'Erreur',
              text: 'Votre session a expiré',
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-check',
              position: 'top-right'
            })
            this.$router.push({name: "login"})
          }
        })
      },
      truncateString(str, num) {
        if (str.length <= num) {
          return str
        }
        return str.slice(0, num) + '...'
      }
    },
    mounted() {
      this.getTreatementTimeByRequests()
    }
  }
</script>

<style scoped>

</style>
